import React from 'react'
import { useRoute } from 'wouter'

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { BillOfMaterials } from '@/state'
import { DocumentTemplate } from './DocumentTemplate'

export const MAX_PARTS_PER_PAGE = 12
export const BillOfMaterialsDocument = ({
  versionName,
  createdAt,
  isLatestDocumentVersion,
  fullScreen,
  parentRef,
  parts = [],
  index,
}: {
  versionName: string
  createdAt: string
  isLatestDocumentVersion?: boolean
  fullScreen?: boolean
  parentRef?: any
  parts: BillOfMaterials
  index: number
}) => {
  const [isPrintPage] = useRoute('/p/:projectId/document/:documentId/print')
  const Wrapper = isPrintPage ? React.Fragment : 'div'

  return (
    <Wrapper ref={parentRef}>
      <DocumentTemplate
        id={`parts-bom--${index}`}
        title="Bill of Materials"
        createdAt={createdAt}
        versionName={versionName}
        isLatestDocumentVersion={isLatestDocumentVersion}
        order={3 + index}
        fullScreen={fullScreen}
      >
        <div id="bom">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Part name</TableHead>
                <TableHead>Quantity</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {parts.map((part, i) => (
                <TableRow key={i}>
                  <TableCell className="py-1 px-2.5">{part.partName}</TableCell>
                  <TableCell className="py-1 px-2.5">
                    {part.quantity ? part.quantity : ''}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </DocumentTemplate>
    </Wrapper>
  )
}
